module.exports = __webpack_public_path__ + "img/A-Student.a3b8f5fb.png";